import { nanoid } from "nanoid"
import { md5 } from "js-md5"
import { debug } from "./print"
import { SECURE_STORAGE_KEY_DEVICE_ID } from "./storage/storage-keys"
import { secureStorage } from "./secureStorage"

export const newID = (): string => nanoid()

export const genPrivacyChatID = (id1: number, id2: number) => {
  const head = id1 > id2 ? id2 : id1
  const tail = id1 > id2 ? id1 : id2
  const title = `${head}:${tail}`
  const chat_id = md5(title)
  return { title, chat_id }
}

export const getDeviceId = async () => {
  let deviceId = await secureStorage.getItemAsync(SECURE_STORAGE_KEY_DEVICE_ID)
  if (!deviceId) {
    deviceId = nanoid()
    await secureStorage.setItemAsync(SECURE_STORAGE_KEY_DEVICE_ID, deviceId)
  }
  debug(`[DEVICE_ID] ${deviceId}`)
  return deviceId
}
